
// import React from 'react';
// import './issues.css';

// const Issues = () => {
//   return (
//     <div className="issues-page">
//       <h1 className="issues-page__title" style={{fontFamily: "Poppins-Medium", }}>Issues</h1>
//       <hr className="issues-page__divider" />
//       <div className="issues-page__grid">
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__image-placeholder"></div>
//             <p className="issues-page__caption">JANUARY 2025</p>
//           </div>
//         </div>
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__image-placeholder"></div>
//             <p className="issues-page__caption">APRIL 2025</p>
//           </div>
//         </div>
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__image-placeholder"></div>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__image-placeholder"></div>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Issues;







// import React from 'react';
// import './issues.css';

// const Issues = () => {
//   return (
//     <div className="issues-page">
//       <h1 className="issues-page__title" style={{ fontFamily: 'Poppins-Medium' }}>Issues</h1>
//       <hr className="issues-page__divider" />
//       <div className="issues-page__grid">
//         {/* Issue 1 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__flipbook">
//               <iframe
//                 src="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//                 width="100%"
//                 height="380"
//                 scrolling="no"
//                 frameBorder="0"
//                 allow="clipboard-write; autoplay; fullscreen"
//                 className="publuuflip"
//               ></iframe>
//             </div>
//             <p className="issues-page__caption">JANUARY 2025</p>
//           </div>
//         </div>

//         {/* Issue 2 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__flipbook">
//               <iframe
//                 src="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//                 width="100%"
//                 height="380"
//                 scrolling="no"
//                 frameBorder="0"
//                 allow="clipboard-write; autoplay; fullscreen"
//                 className="publuuflip"
//               ></iframe>
//             </div>
//             <p className="issues-page__caption">APRIL 2025</p>
//           </div>
//         </div>

//         {/* Issue 3 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__flipbook">
//               <iframe
//                 src="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//                 width="100%"
//                 height="380"
//                 scrolling="no"
//                 frameBorder="0"
//                 allow="clipboard-write; autoplay; fullscreen"
//                 className="publuuflip"
//               ></iframe>
//             </div>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>

//         {/* Issue 4 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <div className="issues-page__flipbook">
//               <iframe
//                 src="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//                 width="100%"
//                 height="380"
//                 scrolling="no"
//                 frameBorder="0"
//                 allow="clipboard-write; autoplay; fullscreen"
//                 className="publuuflip"
//               ></iframe>
//             </div>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Issues;








// import React from 'react';
// import './issues.css';
// import coverImage1 from '../../main_assets/mag4.png'; 
// import coverImage2 from '../../main_assets/mag2.png';
// import coverImage3 from '../../main_assets/mag3.png';
// import coverImage4 from '../../main_assets/mag1.png';

// const Issues = () => {
//   return (
//     <div className="issues-page">
//       <h1 className="issues-page__title" style={{ fontFamily: 'Poppins-Medium' }}>Issues</h1>
//       <hr className="issues-page__divider" />
//       <div className="issues-page__grid">
//         {/* Issue 1 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <a
//               href="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={coverImage1} alt="January 2025 Issue" className="issues-page__cover" />
//             </a>
//             <p className="issues-page__caption">JANUARY 2025</p>
//           </div>
//         </div>

//         {/* Issue 2 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <a
//               href="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={coverImage2} alt="April 2025 Issue" className="issues-page__cover" />
//             </a>
//             <p className="issues-page__caption">APRIL 2025</p>
//           </div>
//         </div>

//         {/* Issue 3 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <a
//               href="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={coverImage3} alt="August 2025 Issue" className="issues-page__cover" />
//             </a>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>

//         {/* Issue 4 */}
//         <div className="issues-page__item">
//           <div className="issues-page__content">
//             <a
//               href="https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={coverImage4} alt="August 2025 Issue" className="issues-page__cover" />
//             </a>
//             <p className="issues-page__caption">AUGUST 2025</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Issues;






import React, { useState } from 'react';
import './issues.css';
import { Link } from 'react-router-dom';
import coverImage1 from '../../main_assets/mag4.png'; 
import coverImage2 from '../../main_assets/mag2.png';
import coverImage3 from '../../main_assets/mag3.png';
import coverImage4 from '../../main_assets/mag1.png';

const issues = [
  {
    id: '1',
    title: 'JANUARY 2025',
    coverImage: coverImage1,
    link: 'https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent',
  },
  {
    id: '2',
    title: 'APRIL 2025',
    coverImage: coverImage2,
    link: 'https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent',
  },
  {
    id: '3',
    title: 'AUGUST 2025',
    coverImage: coverImage3,
    link: 'https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent',
  },
  {
    id: '4',
    title: 'AUGUST 2025',
    coverImage: coverImage4,
    link: 'https://publuu.com/flip-book/737099/1634596/page/4?embed&transparent',
  },
];

const Issues = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading issues...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );


  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
  //       <p className="ml-4 text-lg">Loading Issues...</p>
  //     </div>
  //   );
  // }
  

  return (
    <div className="issues-page">
      <h1 className="issues-page__title" style={{ fontFamily: 'Poppins-Medium' }}>Issues</h1>
      <hr className="issues-page__divider" />
      <div className="issues-page__grid">
        {issues.map((issue) => (
          <div className="issues-page__item" key={issue.id}>
            <div className="issues-page__content">
              <Link to={`/issues/${issue.id}`} state={{ issue }}>
                <img src={issue.coverImage} alt={`${issue.title} Cover`} className="issues-page__cover" />
              </Link>
              <p className="issues-page__caption">{issue.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Issues;
